<template>
  <!-- Documentos Visualizados -->
  <div>
    <div class="container-modern">
      <div class="table-section">
        <div class="table-card">
          <b-overlay :show="loading" opacity="0.99" class="loading-overlay">
            <v-data-table
              :headers="headers"
              :items="docsUsers"
              item-key="id"
              :footer-props="{
                'items-per-page-options': [10, 50, 100],
                'items-per-page-text': 'Mostrar',
              }"
              class="modern-table"
              :no-data-text="'Nenhum documento encontrado'"
              :loading="loading"
              :loading-text="'Carregando documentos...'"
            >
              <template v-slot:[`item.updated_at`]="{ item }">
                {{ formatDate(item.updated_at) }}
              </template>
            </v-data-table>
          </b-overlay>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../services/api";

import { formatDate } from "../../lib/format";

export default {
  name: "ViewedBy",

  data() {
    return {
      docsUsers: [],

      loading: false,

      headers: [
        {
          text: "Nome da Pasta",
          value: "folder_name",
        },
        {
          text: "Nome do Arquivo",
          value: "doc_name",
        },
        {
          text: "Data e Hora da Vizualização",
          value: "updated_at",
        },
      ],
    };
  },

  props: {
    user_id: [Number],
  },

  created() {
    this.getDocs();
  },

  methods: {
    formatDate,

    async getDocs() {
      try {
        this.loading = true;

        const { user_id } = this;

        const response = await api.get("/folder/user/read-doc/by-user", {
          params: { user_id },
        });

        const { docsUsers } = response.data;

        this.docsUsers = docsUsers;

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },
  },
};
</script>